import { useMemo } from 'react';
import { useUI } from 'hooks';
import { HEADER_HEIGHT, HEADER_HEIGHT_DESKTOP } from 'constants';
import { USP_BANNER_HEIGHT } from 'components/layout/uspBanner';
import { Image } from 'components/shared';
import { Spinner } from 'components/shared/icons/ui';

const AccountWrapper = ({ backgroundImage, children, className, loadingOverlay }) => {
  const { displayUspBanner } = useUI();
  const shiftHeader = useMemo(() => {
    if (displayUspBanner) {
      return USP_BANNER_HEIGHT;
    }

    return '0px';
  }, [displayUspBanner]);

  return (
    <div
      style={{
        '--headerDesktop': HEADER_HEIGHT_DESKTOP ?? '75px',
        '--header': HEADER_HEIGHT ?? '50px',
        '--shiftHeader': shiftHeader,
      }}
      className={`group/account-wrapper grid min-h-[calc(100dvh-var(--header)-var(--shiftHeader))] w-full grid-cols-1 md:h-auto md:max-h-[90rem] md:min-h-[calc(100dvh-var(--headerDesktop)-var(--shiftHeader))] md:grid-cols-2 ${className}`}
    >
      {loadingOverlay && (
        <div className="fixed bottom-0 left-0 right-0 top-0 z-50 grid place-items-center bg-white bg-opacity-50">
          <Spinner className="h-40" />
        </div>
      )}
      <div className="relative hidden md:block">
        <Image src={backgroundImage} layout="fill" className="" />
      </div>
      <div className="grid place-items-start px-6 py-20 md:place-items-center md:px-[10.833vw] md:py-[10.469rem]">
        {children}
      </div>
    </div>
  );
};

export default AccountWrapper;
